// Could be made into a plugin with an #install method?
export default function storePaymentDetails (vueInstance, lokalStorage) {
  const tmp = { ...vueInstance.paymentStore.details }
  const parsedPayment = JSON.stringify(tmp)
  lokalStorage.setItem('payment', parsedPayment)
  lokalStorage.location = vueInstance.$l10n.currentLocation.key
}
